import dynamic from "next/dynamic";

export const DynamicContent074 = dynamic(() => import("./Content074"), {
  suspense: true,
});
